// The splash screen (index.html, #splash): the app icon and "Tilez" on black from the first
// frame, until the app has something to show. iOS shows the same on its launch screen, and keeps it
// until the page has loaded (CasaApp.swift); Android shows black (scripts/make-app-icons.mjs, the
// Android theme).

const FADE_MS = 250;
/** Shown this long at least, from the page's start: a dashboard kept on the device is there at once. */
const SHORTEST_MS = 1_000;
/** Gone after this at the latest, whatever happens: a splash must never hide an error. */
const LONGEST_MS = 10_000;

let isHidden = false;

/** Fades the splash screen out and removes it; once is enough, later calls do nothing. */
export function hideSplash() : void {
    if (isHidden) {
        return;
    }

    isHidden = true;
    const splash = document.getElementById('splash');
    if (!splash) {
        return;
    }

    setTimeout(() => {
        splash.style.opacity = '0';
        setTimeout(() => splash.remove(), FADE_MS);
    }, Math.max(0, SHORTEST_MS - performance.now()));
}

setTimeout(hideSplash, LONGEST_MS);
